module.exports = __webpack_public_path__ + "static/media/regal-rush-vertical-transparent-bg-gold-250x250.8419f678.png";